var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-full"},[_c('cnd-icon',{attrs:{"name":_vm.isFull ? 'cnd-fullScreen-close' : 'cnd-fullScreen'},on:{"click":_vm.handleFullScreen}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }